import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
const _excluded = ["submissionId"],
  _excluded2 = ["FEDERAL"];
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/splice";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find-index";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { updateField } from "@joandvgv/vuex-map-fields";
import { FORMS_SUBMISSION_DEPENDANT } from "@Shared/@Utils/constants";
import { keys, mapValues, set, values, without } from "lodash";
import Vue from "vue";
export const SET_SUBMISSION_HISTORY = "SET_SUBMISSION_HISTORY";
export const ADD_SUBMISSION_RECORD = "ADD_SUBMISSION_RECORD";
export const UPDATE_SUBMISSION_RECORD = "UPDATE_SUBMISSION_RECORD";
export const SET_VALIDATION_RULES_RESULT = "SET_VALIDATION_RULES_RESULT";
export const SET_LENDERS = "SET_LENDERS";
export const SET_PARTICIPANTS = "SET_PARTICIPANTS";
export const SET_CREDIT_SUBJECTS = "SET_CREDIT_SUBJECTS";
export const SET_CREDIT_REPORTS = "SET_CREDIT_REPORTS";
export const SET_ADDITIONAL_REPORTS = "SET_ADDITIONAL_REPORTS";
export const SET_REQUESTING_BUREAU_STATUS = "SET_REQUESTING_BUREAU_STATUS";
export const SET_DOCUMENT_FORMS = "SET_DOCUMENT_FORMS";
export const SET_EDITING_DOCUMENT_FORM = "SET_EDITING_DOCUMENT_FORM";
export const SET_DOCUMENT_FORM_SELECTION = "SET_DOCUMENT_FORM_SELECTION";
export const EDIT_DOCUMENT_FORM = "EDIT_DOCUMENT_FORM";
export const ADD_FEE_COST = "ADD_FEE_COST";
export const REMOVE_FEE_COST = "REMOVE_FEE_COST";
export const ADD_SUBMISSION_AGENT = "ADD_SUBMISSION_AGENT";
export const EDIT_SUBMISSION_AGENT = "EDIT_SUBMISSION_AGENT";
export const SET_SUBMIT_TO_LENDER_FLAG = "SET_SUBMIT_TO_LENDER_FLAG";
export const SET_APPLICATION_FEES = "SET_APPLICATION_FEES";
export const SET_FEES_CALCULATED_DETAILS = "SET_FEES_CALCULATED_DETAILS";
export const SET_APPLICATION_FEES_SAVING_STATUS = "SET_APPLICATION_FEES_SAVING_STATUS";
export const SET_APPLICATION_FEES_UPDATED_AT = "SET_APPLICATION_FEES_UPDATED_AT";
export const SET_LENDER_NOTE = "SET_LENDER_NOTE";
export const SET_SUBMISSION_HISTORY_STATUS = "SET_SUBMISSION_HISTORY_STATUS";
export const SET_MPP_DATA = "SET_MPP_DATA";
export const SET_MANUAL_RESPONSE = "SET_MANUAL_RESPONSE";
export const ADD_MPP = "ADD_MPP";
export const SET_SUBMISSION_AGENTS = "SET_SUBMISSION_AGENTS";
export const SET_COMMISSIONS_FEES = "SET_COMMISSIONS_FEES";
export const ADD_COMMISSION_FEE = "ADD_COMMISSION_FEE";
export const REMOVE_COMMISSION_FEE = "REMOVE_COMMISSION_FEE";
export const SET_COMMISSION_FEE = "SET_COMMISSION_FEE";
export const SET_COMMISSIONS_FEE_MORTGAGE_TYPE = "SET_COMMISSIONS_FEE_MORTGAGE_TYPE";
export const ADD_COMMISSION_DEDUCTION = "ADD_COMMISSION_DEDUCTION";
export const DELETE_COMMISSION_DEDUCTION = "DELETE_COMMISSION_DEDUCTION";
export const UPDATE_COMMISSION_DEDUCTION = "UPDATE_COMMISSION_DEDUCTION";
export const SET_COMMISSION_DEDUCTION = "SET_COMMISSION_DEDUCTION";
export const SET_COMMISSION_CALCULATED_DETAILS = "SET_COMMISSION_CALCULATED_DETAILS";
export const SET_COMMISSIONS_DETAILS = "SET_COMMISSIONS_DETAILS";
export const SET_COMMISSIONS_DETAILS_PARTICIPANT = "SET_COMMISSIONS_DETAILS_PARTICIPANT";
export const SET_APPLICATION_COMMISSIONS_DETAILS = "SET_APPLICATION_COMMISSIONS_DETAILS";
export const SET_COMMISSIONS_DETAILS_PRIMARY_CONTACT = "SET_COMMISSIONS_DETAILS_PRIMARY_CONTACT";
export const DELETE_COMMISSIONS_DETAILS_PARTICIPANT = "DELETE_COMMISSIONS_DETAILS_PARTICIPANT";
export const SET_TOTAL_COMMISSIONS_FEES = "SET_TOTAL_COMMISSIONS_FEES";
export const SET_LOADING_TOTAL_COMMISSIONS_FEES = "SET_LOADING_TOTAL_COMMISSIONS_FEES";
export const SET_CO_BROKERING_HISTORY = "SET_CO_BROKERING_HISTORY";
export const SET_CO_BROKER_BROKERAGES = "SET_CO_BROKER_BROKERAGES";
export const RESET_CO_BROKER_BROKERAGES = "RESET_CO_BROKER_BROKERAGES";
export const SET_CO_BROKER_BROKERAGES_COUNT = "SET_CO_BROKER_BROKERAGES_COUNT";
export const SET_CO_BROKER_AGENTS = "SET_CO_BROKER_AGENTS";
export const RESET_CO_BROKER_AGENTS = "RESET_CO_BROKER_AGENTS";
export const SET_LOADING_CO_BROKER_AGENTS = "SET_LOADING_CO_BROKER_AGENTS";
export const SET_CO_BROKER_AGENTS_COUNT = "SET_CO_BROKER_AGENTS_COUNT";
export default {
  [SET_SUBMISSION_HISTORY]: (state, {
    submissionHistory
  }) => {
    state.submissionHistory = submissionHistory;
  },
  [ADD_SUBMISSION_RECORD]: (state, _ref) => {
    let {
        submissionRecord: {
          submissionId
        }
      } = _ref,
      submissionRecord = _objectWithoutProperties(_ref.submissionRecord, _excluded);
    state.submissionHistory.byId = _objectSpread(_objectSpread({}, state.submissionHistory.byId), {}, {
      [submissionId]: submissionRecord
    });
    state.submissionHistory.allIds.push(submissionRecord.submissionId);
  },
  [UPDATE_SUBMISSION_RECORD]: (state, {
    submissionId,
    details
  }) => {
    state.submissionHistory.byId[submissionId] = _objectSpread(_objectSpread({}, state.submissionHistory.byId[submissionId]), details);
  },
  [SET_VALIDATION_RULES_RESULT]: (state, {
    applicationId,
    validationRulesResult
  }) => {
    var _context;
    state.validationRulesResult.byId = _objectSpread(_objectSpread({}, state.validationRulesResult.byId), {}, {
      [applicationId]: validationRulesResult
    });
    if (_includesInstanceProperty(_context = state.validationRulesResult.allIds).call(_context, applicationId)) return;
    state.validationRulesResult.allIds.push(applicationId);
  },
  [SET_LENDERS]: (state, {
    lenders
  }) => {
    state.lenders = lenders;
  },
  [SET_CREDIT_SUBJECTS]: (state, {
    creditSubjects
  }) => {
    const emptyState = {
      firstName: "",
      lastName: "",
      dateOfBirth: "",
      address: {},
      authorizationDate: "",
      authorizationMethod: "",
      bureau: false,
      copyLiabilities: false,
      AML: false,
      PEP: false
    };
    const creditSubjectsData = _mapInstanceProperty(creditSubjects).call(creditSubjects, subject => _objectSpread(_objectSpread({}, emptyState), subject));
    state.creditSubjects = creditSubjectsData;
  },
  [SET_CREDIT_REPORTS]: (state, {
    creditReports
  }) => {
    state.creditReports = creditReports;
  },
  [SET_ADDITIONAL_REPORTS]: (state, {
    additionalReports
  }) => {
    state.additionalReports = additionalReports;
  },
  [SET_PARTICIPANTS]: (state, {
    agent = {},
    submissionAgents = {}
  }) => {
    state.participants = {
      agent,
      submissionAgents
    };
  },
  [SET_SUBMISSION_AGENTS]: (state, {
    submissionAgents = {}
  }) => {
    state.participants.submissionAgents = submissionAgents;
  },
  [ADD_SUBMISSION_AGENT]: (state, submissionAgent) => {
    const {
      submissionAgentId
    } = submissionAgent;
    state.participants.submissionAgents.byId = _objectSpread(_objectSpread({}, state.participants.submissionAgents.byId), {}, {
      [submissionAgentId]: submissionAgent
    });
    state.participants.submissionAgents.allIds.push(submissionAgentId);
  },
  [EDIT_SUBMISSION_AGENT]: (state, {
    submissionAgent
  }) => {
    const {
      submissionAgentId
    } = submissionAgent;
    state.participants.submissionAgents.byId = _objectSpread(_objectSpread({}, state.participants.submissionAgents.byId), {}, {
      [submissionAgentId]: submissionAgent
    });
  },
  [SET_REQUESTING_BUREAU_STATUS]: (state, status) => {
    state.requestingCreditBureau = status;
  },
  [SET_DOCUMENT_FORMS]: (state, {
    documentForms,
    applicationId
  }) => {
    var _context2;
    const {
        FEDERAL: federalForms
      } = documentForms,
      provinceForms = _objectWithoutProperties(documentForms, _excluded2);
    const province = keys(provinceForms)[0];
    const mapper = province => (form, formKey) => {
      form.mortgagesSelected = [];
      form.province = province;
      form.formKey = formKey;
      return form;
    };
    const forms = [...values(mapValues(federalForms, mapper("FEDERAL"))), ...values(mapValues(provinceForms[province], mapper(province)))];
    const formsByKey = _reduceInstanceProperty(forms).call(forms, (acc, curr) => {
      acc[curr.formKey] = curr;
      return acc;
    }, {});
    state.documentForms.byId = _objectSpread(_objectSpread({}, state.documentForms.byId), {}, {
      [applicationId]: formsByKey
    });
    if (_includesInstanceProperty(_context2 = state.documentForms.allIds).call(_context2, applicationId)) return;
    state.documentForms.allIds.push(applicationId);
  },
  [SET_EDITING_DOCUMENT_FORM]: (state, formData) => {
    state.editingDocumentForm = formData;
  },
  [EDIT_DOCUMENT_FORM]: (state, {
    formKey,
    mortgageType,
    applicationId
  }) => {
    const form = state.documentForms.byId[applicationId][formKey];
    const currentSelection = form.mortgagesSelected;
    if (_includesInstanceProperty(currentSelection).call(currentSelection, mortgageType)) {
      form.mortgagesSelected = without(currentSelection, mortgageType);
    } else {
      currentSelection.push(mortgageType);
    }
  },
  [SET_DOCUMENT_FORM_SELECTION]: (state, {
    applicationId,
    mortgagesSelected,
    formSelectionEnabled
  }) => {
    const documentForms = mapValues(state.documentForms.byId[applicationId], form => form.type === "link" || formSelectionEnabled === false && _includesInstanceProperty(FORMS_SUBMISSION_DEPENDANT).call(FORMS_SUBMISSION_DEPENDANT, form.formKey) ? form : _objectSpread(_objectSpread({}, form), {}, {
      mortgagesSelected: [...mortgagesSelected]
    }));
    state.documentForms.byId = _objectSpread(_objectSpread({}, state.documentForms.byId), {}, {
      [applicationId]: documentForms
    });
  },
  [ADD_FEE_COST]: (state, mortgageType) => {
    state.feesCosts[mortgageType].push(state.feeStructure);
  },
  [REMOVE_FEE_COST]: (state, {
    mortgageType,
    index
  }) => {
    var _context3;
    _spliceInstanceProperty(_context3 = state.feesCosts[mortgageType]).call(_context3, index, 1);
  },
  [SET_SUBMIT_TO_LENDER_FLAG]: (state, {
    reportId,
    value
  }) => {
    state.creditReports.byId[reportId].submitToLender = value;
  },
  [SET_APPLICATION_FEES]: (state, {
    applicationFees,
    calculatedDetails,
    updatedAt,
    translationMap
  }) => {
    state.feesCosts = _objectSpread(_objectSpread({}, applicationFees), {}, {
      updatedAt
    });
    state.feesCalculatedDetails = calculatedDetails;
    state.feesTranslationMap = translationMap;
  },
  [SET_APPLICATION_FEES_UPDATED_AT]: (state, newUpdatedAt) => {
    state.feesCosts.updatedAt = newUpdatedAt;
  },
  [SET_APPLICATION_FEES_SAVING_STATUS]: (state, status) => {
    state.feesSavingStatus = status;
  },
  [SET_LENDER_NOTE]: async (state, {
    applicationId,
    lenderNote
  }) => {
    set(state.lenderNotes, applicationId, lenderNote);
  },
  [SET_SUBMISSION_HISTORY_STATUS]: async (state, {
    submissionId,
    status
  }) => {
    set(state.submissionHistory.byId[submissionId], "status", status);
  },
  [SET_MPP_DATA]: (state, {
    mpp
  }) => {
    state.mpp = mpp;
  },
  [SET_MANUAL_RESPONSE]: (state, {
    loanDecision
  }) => {
    const {
      applicationId
    } = loanDecision.deal;
    Vue.set(state.submissionManualResponse.byId, applicationId, loanDecision);
    Vue.set(state, "currentManualResponseId", applicationId);
    if (!state.submissionManualResponse.allIds.some(item => item === applicationId)) state.submissionManualResponse.allIds.push(applicationId);
  },
  [ADD_MPP]: (state, mpp) => {
    var _context4;
    if (!_includesInstanceProperty(_context4 = state.mpp.allIds).call(_context4, mpp.submissionId)) state.mpp.allIds.push(mpp.submissionId);
    Vue.set(state.mpp.byId, mpp.submissionId, mpp);
  },
  [SET_COMMISSIONS_FEES]: (state, {
    commissionsFees,
    mortgageType
  }) => {
    const {
      currentApplicationId
    } = state;
    const allCommissionsFees = {
      byApplication: _objectSpread(_objectSpread({}, state.commissions.fees.byApplication), {}, {
        [currentApplicationId]: _objectSpread(_objectSpread({}, state.commissions.fees.byApplication[currentApplicationId] || {}), {}, {
          [mortgageType]: commissionsFees
        })
      })
    };
    Vue.set(state.commissions, "fees", allCommissionsFees);
  },
  [ADD_COMMISSION_FEE]: (state, {
    mortgageType = "first",
    commissionsFeeId
  }) => {
    const newCommissionFee = _objectSpread(_objectSpread({}, state.emptyCommissionFee), {}, {
      mortgageType,
      commissionsFeeId
    });
    const {
      currentApplicationId
    } = state;
    const currentCommissionFees = state.commissions.fees.byApplication[currentApplicationId][mortgageType];
    currentCommissionFees.allIds.push(commissionsFeeId);
    currentCommissionFees.byId = _objectSpread(_objectSpread({}, currentCommissionFees.byId), {}, {
      [commissionsFeeId]: newCommissionFee
    });
  },
  [REMOVE_COMMISSION_FEE]: (state, {
    commissionsFeeId,
    mortgageType = "first"
  }) => {
    var _context5;
    const {
      currentApplicationId
    } = state;
    delete state.commissions.fees.byApplication[currentApplicationId][mortgageType].byId[commissionsFeeId];
    state.commissions.fees.byApplication[currentApplicationId][mortgageType].allIds = _filterInstanceProperty(_context5 = state.commissions.fees.byApplication[currentApplicationId][mortgageType].allIds).call(_context5, feeId => feeId !== commissionsFeeId);
  },
  [SET_COMMISSION_FEE]: (state, {
    fee,
    mortgageType
  }) => {
    const {
      currentApplicationId
    } = state;
    Vue.set(state.commissions.fees.byApplication[currentApplicationId][mortgageType].byId, fee.commissionsFeeId, fee);
  },
  [SET_LOADING_TOTAL_COMMISSIONS_FEES]: (state, loading) => {
    state.loadingTotalCommissionFees = loading;
  },
  [SET_COMMISSIONS_DETAILS]: (state, {
    applicationId,
    commissionsDetails
  }) => {
    Vue.set(state.commissions.commissionDetails.byApplication, applicationId, commissionsDetails);
  },
  [SET_COMMISSIONS_DETAILS_PARTICIPANT]: (state, {
    applicationId,
    participant
  }) => {
    var _state$commissions$co, _state$commissions$co2;
    if (!((_state$commissions$co = state.commissions.commissionDetails.byApplication) != null && (_state$commissions$co2 = _state$commissions$co[applicationId]) != null && _state$commissions$co2.participants.allIds[participant.commissionsParticipantId])) {
      state.commissions.commissionDetails.byApplication[applicationId].participants.allIds.push(participant.commissionsParticipantId);
    }
    Vue.set(state.commissions.commissionDetails.byApplication[applicationId].participants.byId, participant.commissionsParticipantId, participant);
  },
  [SET_COMMISSIONS_FEE_MORTGAGE_TYPE]: (state, mortgageType) => {
    Vue.set(state.commissions, "currentCommissionsMortgageType", mortgageType);
  },
  [ADD_COMMISSION_DEDUCTION]: (state, {
    applicationId,
    commissionsDeductionId
  }) => {
    var _state$commissions$de, _state$commissions$de2;
    if ((_state$commissions$de = state.commissions.deductions.byApplication) != null && (_state$commissions$de2 = _state$commissions$de[applicationId]) != null && _state$commissions$de2.allIds) {
      state.commissions.deductions.byApplication[applicationId].allIds.push(commissionsDeductionId);
      Vue.set(state.commissions.deductions.byApplication[applicationId].byId, commissionsDeductionId, _objectSpread(_objectSpread({}, state.commissions.deductionStructure), {}, {
        commissionsDeductionId
      }));
    } else {
      Vue.set(state.commissions.deductions.byApplication, applicationId, {
        allIds: [commissionsDeductionId],
        byId: {
          commissionsDeductionId: _objectSpread(_objectSpread({}, state.commissions.deductionStructure), {}, {
            commissionsDeductionId
          })
        }
      });
    }
  },
  [DELETE_COMMISSION_DEDUCTION]: (state, {
    applicationId,
    commissionsDeductionId
  }) => {
    var _context6;
    delete state.commissions.deductions.byApplication[applicationId].byId[commissionsDeductionId];
    state.commissions.deductions.byApplication[applicationId].allIds = _filterInstanceProperty(_context6 = state.commissions.deductions.byApplication[applicationId].allIds).call(_context6, deductionId => deductionId !== commissionsDeductionId);
  },
  [UPDATE_COMMISSION_DEDUCTION]: (state, {
    applicationId,
    commissionsDeductionId,
    deduction
  }) => {
    Vue.set(state.commissions.deductions.byApplication[applicationId].byId, commissionsDeductionId, deduction);
  },
  [SET_COMMISSION_DEDUCTION]: (state, {
    applicationId,
    commissionDeductions = {}
  }) => {
    Vue.set(state.commissions.deductions.byApplication, applicationId, commissionDeductions);
  },
  [SET_COMMISSION_CALCULATED_DETAILS]: (state, {
    applicationId,
    totalDeductions
  }) => {
    Vue.set(state.commissions.deductions.byApplication[applicationId], "totalDeductions", totalDeductions);
  },
  [SET_COMMISSIONS_DETAILS_PRIMARY_CONTACT]: (state, {
    applicationId,
    oldPrimaryContact,
    newPrimaryContact
  }) => {
    Vue.set(state.commissions.commissionDetails.byApplication[applicationId].participants.byId[oldPrimaryContact], "primaryContact", false);
    Vue.set(state.commissions.commissionDetails.byApplication[applicationId].participants.byId[newPrimaryContact], "primaryContact", true);
  },
  [DELETE_COMMISSIONS_DETAILS_PARTICIPANT]: (state, {
    applicationId,
    commissionsParticipantId
  }) => {
    var _context7, _context8;
    Vue.delete(state.commissions.commissionDetails.byApplication[applicationId].participants.byId, commissionsParticipantId);
    const index = _findIndexInstanceProperty(_context7 = state.commissions.commissionDetails.byApplication[applicationId].participants.allIds).call(_context7, id => id === commissionsParticipantId);
    _spliceInstanceProperty(_context8 = state.commissions.commissionDetails.byApplication[applicationId].participants.allIds).call(_context8, index, 1);
  },
  [SET_TOTAL_COMMISSIONS_FEES]: (state, {
    totalFees
  }) => {
    state.totalCommissionFees = totalFees;
  },
  [SET_CO_BROKERING_HISTORY]: (state, {
    coBrokeringHistory
  }) => {
    state.coBrokering.coBrokeringHistory = coBrokeringHistory;
  },
  [SET_CO_BROKER_BROKERAGES]: (state, {
    brokerages
  }) => {
    state.coBrokering.brokerages = [...state.coBrokering.brokerages, ...brokerages];
  },
  [RESET_CO_BROKER_BROKERAGES]: state => {
    state.coBrokering.brokerages = [];
  },
  [SET_CO_BROKER_BROKERAGES_COUNT]: (state, {
    brokerageCount
  }) => {
    state.coBrokering.brokerageCount = brokerageCount;
  },
  [SET_CO_BROKER_AGENTS]: (state, {
    totalAgents,
    agents
  }) => {
    state.coBrokering.agents = agents;
    state.coBrokering.totalAgents = totalAgents;
  },
  [SET_CO_BROKER_AGENTS_COUNT]: (state, {
    totalAgents
  }) => {
    state.coBrokering.totalAgents = totalAgents;
  },
  [RESET_CO_BROKER_AGENTS]: state => {
    state.coBrokering.agents = [];
    state.coBrokering.totalAgents = 0;
  },
  [SET_LOADING_CO_BROKER_AGENTS]: (state, {
    loading
  }) => {
    state.coBrokering.loadingAgents = loading;
  },
  updateField
};